import React from 'react';

import { questionTypeMenuFor } from 'js/utils/questions';
import ActionSelector from '../ActionSelector';

export function QuestionType({
  type,
  assessmentType = 'survey',
  onChange = () => {},
}) {
  const options = questionTypeMenuFor(assessmentType).map(([key, meta]) => ({
    key,
    name: meta.name,
    icon: meta.icon,
  }));

  return <ActionSelector value={type} options={options} onChange={onChange} />;
}

export default QuestionType;
